<template>
	<span>
		<b-badge :variant="variant">{{ status }}</b-badge>
	</span>
</template>

<script>
export default {
	props: {
		status: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			statusPrimary: ['ATIVO', 'ATIVA', 'SIM', 'VIGENTE', 'APLICADOS'],
			statusInfo: ['PAGA'],
			statusSuccess: ['NO PRAZO', 'LIQUIDADO'],
			statusWarning: ['DEVOLVIDA', 'MODIFICADOS'],
			statusSecondary: ['INATIVO', 'INATIVA'],
			statusDanger: ['NÃO', 'VENCIDA']
		}
	},

	computed: {
		variant() {
			if (
				this.statusPrimary.filter(item => {
					return item === this.status
				}).length > 0
			) {
				return 'primary'
			} else if (
				this.statusInfo.filter(item => {
					return item === this.status
				}).length > 0
			) {
				return 'info'
			} else if (
				this.statusSuccess.filter(item => {
					return item === this.status
				}).length > 0
			) {
				return 'success'
			} else if (
				this.statusWarning.filter(item => {
					return item === this.status
				}).length > 0
			) {
				return 'warning'
			} else if (
				this.statusSecondary.filter(item => {
					return item === this.status
				}).length > 0
			) {
				return 'secondary'
			} else if (
				this.statusDanger.filter(item => {
					return item === this.status
				}).length > 0
			) {
				return 'danger'
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/StatusComponent.vue